import { get } from '../lib/api';

export function getBannerFor(growerId) {
  return get(`/growers/${growerId}/banner`);
}
